

























import { Component, Mixins, Prop } from 'vue-property-decorator';
import mixin from '../../mixins/mixin.ts';
import ExtLink from '@/components/ext/Link.vue';
import { ButtonDefault } from '@/components/parts/button';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';

@Component({
  components: {
    ExtLink,
    ButtonDefault,
    AppButtonNew,
  },
})
export default class ComponentsPartsBlogListComponentsItem extends Mixins(
  mixin
) {
  // Props
  @Prop({ type: Boolean, default: false })
  aside: boolean;

  @Prop({ type: Boolean, default: false })
  flex: boolean;

  get getEventType() {
    const ret = this.$store.state.blogEventsDict.find((sprElem: any) => {
      return sprElem.id === this.event_type;
    });
    if (ret) {
      return ret.name;
    }
    return '';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/blog/list/components/Item.vue